import React from "react";

import TimeInput from "../../../ui/components/DateInput/TimeInput";

import useFormField from "../../hooks/useFormField";

export default function FormTimeInput(props) {
	const { field } = useFormField(props);

	return <TimeInput {...field} value={field.value} ref={undefined} />;
}
